import styles from './styles.scss';
import { SuggestedPhrase } from 'models/SuggestedPhrase';
import { NotifyLink } from 'components/Shared/NotifyLink';

interface OwnProps {
  searchString: string;
  searchUrl: string;
  suggestions: SuggestedPhrase[];
  txtNoHits: string;
  txtDidYouMean: string;
}

export default ({ searchString, searchUrl, suggestions, txtNoHits, txtDidYouMean }: OwnProps) => {
  return (
    <div className={styles.didYouMean}>
      <div className={styles.phrase}>
        {txtNoHits} <strong>{searchString}</strong>
      </div>
      {suggestions.length > 0 && (
        <div className={styles.suggestion}>
          {txtDidYouMean}&nbsp;
          <NotifyLink
            url={`${searchUrl}?phrase=${suggestions[0].phrase}`}
            ticket={suggestions[0].ticket}
          >
            {suggestions[0].phrase}
          </NotifyLink>
          ?
        </div>
      )}
    </div>
  );
};
